import { Guideline } from "../../ts/models/POD";
import { sanitizedHtml } from "../../utils";
import classes from "./GuidelineCard.module.css";

type Props = {
  data: Guideline;
  style: React.CSSProperties;
};

const GuidelineCard: React.FC<Props> = ({ data, style }) => {
  return (
    <div className={classes.guideline} style={style}>
      <div>
        <div
          className={classes.itemHeading}
          dangerouslySetInnerHTML={{
            __html: sanitizedHtml(data.heading),
          }}></div>
        <div
          className={classes.itemText}
          dangerouslySetInnerHTML={{
            __html: sanitizedHtml(data.text),
          }}></div>
      </div>
    </div>
  );
};

export default GuidelineCard;
